import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-three-hook',
  templateUrl: './three-hook.component.html',
  styleUrls: ['./three-hook.component.scss']
})
export class ThreeHookComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
